import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenDashboardService, RecordRetrievalStatusResponse } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const useRecordRetrievalStatus = () => {
    const [status, setStatus] = useState<RecordRetrievalStatusResponse | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchRecordRetrievalStatus = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<RecordRetrievalStatusResponse> =
                AspenDashboardService.getRecordRetrievalStatusDashboardRecordRetrievalStatusGet()
            const data = await response
            setStatus(data)
        } catch (err) {
            setError('Failed to fetch record retrieval status')
            enqueueSnackbar('Failed to fetch record retrieval status', {
                variant: 'error'
            })
        } finally {
            setLoading(false)
        }
    }, [enqueueSnackbar])

    useEffect(() => {
        fetchRecordRetrievalStatus()
    }, [fetchRecordRetrievalStatus])

    return { status, loading, error, fetchRecordRetrievalStatus }
}
